import { NONZERO_MIN_OPACITY, ZERO_MARK_OPACITY } from './scale';

/**
 * What the scrubber is drawn on top of. It has no surface of its own, so its
 * colours have to hold up against whatever basemap is behind it:
 * - `default` — the vector basemaps (Light / Voyager / Dark). Theme tokens.
 * - `imagery` — satellite (ENG-208). Its greens swallow the green bars and
 *   grey labels, so bars/tooltip switch to lavender and text to haloed white.
 */
export type TimelineScrubberSurface = 'default' | 'imagery';

/**
 * Scoped custom properties set on the scrubber's root; every child reads
 * `--scrubber-*` instead of a theme token, so switching surface is one class
 * swap rather than a prop threaded through each part.
 */
export const SURFACE_VARS: Record<TimelineScrubberSurface, string> = {
  default:
    '[--scrubber-accent:var(--color-green)] [--scrubber-on-accent:var(--color-on-accent)] [--scrubber-label:var(--color-text3)] [--scrubber-halo:none] [--scrubber-bar-edge:none]',
  imagery:
    '[--scrubber-accent:var(--color-imagery-accent)] [--scrubber-on-accent:var(--color-imagery-on-accent)] [--scrubber-label:var(--color-imagery-label)] [--scrubber-halo:var(--shadow-imagery-halo)] [--scrubber-bar-edge:var(--shadow-imagery-edge)]',
};

/**
 * Resting bar opacities (hovered/selected bars are always 1). Imagery raises
 * both floors: a pale bar fades into busy terrain long before it would into
 * a flat vector basemap, and the zero-mark would vanish outright at 0.18.
 * See `scale.ts` for what each floor means.
 */
export const BAR_OPACITY: Record<TimelineScrubberSurface, { zero: number; nonzeroMin: number }> = {
  default: { zero: ZERO_MARK_OPACITY, nonzeroMin: NONZERO_MIN_OPACITY },
  imagery: { zero: 0.55, nonzeroMin: 0.7 },
};
